import { useTranslation } from 'react-i18next';
import { useSnapshotProgress } from '../../hooks/useSnapshotProgress';

/** Баннер загрузки каталога: «Завантажую каталог… k/n» или ошибка загрузки. */
export function SnapshotBanner() {
  const { t } = useTranslation();
  const progress = useSnapshotProgress();

  if (progress.failed && !progress.active) {
    return (
      <div className="snapshot-banner snapshot-banner--error" role="alert">
        <span aria-hidden>⚠️</span>
        <span className="snapshot-banner__text">
          {t('common.snapshotError')}
          {progress.failedUrl ? <code> {progress.failedUrl}</code> : null}
        </span>
      </div>
    );
  }

  if (!progress.active) return null;

  return (
    <div className="snapshot-banner" role="status" aria-live="polite">
      <span className="snapshot-banner__spinner" aria-hidden>
        ⏳
      </span>
      <span className="snapshot-banner__text">
        {progress.firstLoad
          ? t('common.catalogLoading')
          : t('common.snapshotUpdating', { loaded: progress.loaded, total: progress.total })}
      </span>
    </div>
  );
}
